import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

const LineIcon: React.FC<IconProps> = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 20 1" {...props}>
      <line y1="0.5" x2="20" y2="0.5" stroke="currentColor" />
    </Icon>
  );
};

export { LineIcon };
